<template>
    <div>
        <div class="row news-filters__cards" id="lazyload-items">
            <div v-for="post in filteredList" class="col-sm-6 col-md-4 lazyload-item">
                <a :href="getPostLink(post)" class="card card-btn shadow-0">
                    <div class="card-header border-0 rounded">
                        <img
                             :src="_.imgPath((post.image), 'w800-h600-q10')"
                             :data-src="_.imgPath((post.image), 'w800-h600-q80')"
                            :alt="post.name"
                            class="card-img-top blur-up lazyload">
                    </div>
                    <div class="card-body pt-3 pl-0">
                        <h4 class="mb-0">{{ post.name }}</h4>
                        <p class="text-green"><strong>{{ post.subheading }}</strong></p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'moment';
import UtilsMixin from './UtilsMixin';
import SelectBoxComponent from './form/SelectBoxComponent';

export default {
    data() {
        return {
            currentCat: null,
            currentDate: null,
        }
    },

    mounted() {

    },

    props: ['initialData'],

    components: {
        SelectBoxComponent,
    },

    mixins: [UtilsMixin],

    watch: {

    },

    computed: {
        filteredList() {
            return _.chain(this.initialData)
                .get('projects')
                .map(p => ({ ...p,
                    category: this.getProjectCategory(p),
                    timestamp: this.createDate(p.available_at || p.created_at).unix(),
                    date: this.createDate(p.available_at || p.created_at).format('DD MMM YYYY'),
                }))
                .sortBy('position')
                .reverse()
                .filter(p => {
                    let pass = true;
                    if (pass && this.currentCat) {
                        pass = p.project_category_id === this.currentCat;
                    }

                    if (pass && this.currentDate) {
                        const date = this.createDate(p.available_at || p.created_at).format('YYYY-MM-DD');
                        pass = (date <= this.currentDate.max) && (date >= this.currentDate.min);
                    }

                    return pass;
                })
                .value();
        },

        categories() {
            return _.chain(this.initialData)
                .get('posts')
                .map(this.getProjectCategory)
                .filter()
                .sortBy('position')
                .uniqBy('id')
                .value();
        },

        dateList() {
            return _.chain(this.initialData)
                .get('posts')
                .map(p => p.available_at || p.created_at)
                .map(dt => {
                    const date = this.createDate(dt);

                    return {
                        value: date.format('YYYY-MM'),
                        text: date.format('MMMM YYYY'),
                        min: date.format('YYYY-MM-DD'),
                        max: date.add(1, 'month').format('YYYY-MM-DD'),
                    }
                })
                .uniqBy('value')
                .value();
        }
    },

    methods: {
        getProjectCategory(post) {
            return _.chain(this.initialData)
                .get('categories', [])
                .find(cat => cat.id == post.project_category_id)
                .value();
        },

        filterByDate(date) {
            this.currentDate = date;
        },

        filterByCat(cat) {
            this.currentCat = cat;
        },

        createDate(date) {
            return M(date, 'YYYY-MM-DD hh:mm:ss');
        },

        getPostLink(post) {
            return window.location.pathname + '/' + post.name_id;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/ProjectListComponent.vue